/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum RoutesOrder {
  ROUTE_ID="ROUTE_ID",
NAME="NAME"
}

/**
* RoutesOrder
*/
export const RoutesOrderEnumType = types.enumeration("RoutesOrder", [
        "ROUTE_ID",
  "NAME",
      ])
